"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.layerPermissionReducer = void 0;

var _layerPermissionActions = require("../actions/layerPermissionActions");

var _visibilityConfig = _interopRequireDefault(require("../config/visibilityConfig"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var layerPermissionReducer = function layerPermissionReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    layersConfig: [],
    visibilityConfig: _visibilityConfig.default,
    userType: 'UNKNOWN'
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _layerPermissionActions.SET_ALLOWED_LAYERS_SUCCESS:
      return Object.assign({}, _objectSpread(_objectSpread({}, state), {}, {
        layersConfig: action.allowedLayers,
        visibilityConfig: action.visibilityConfig,
        userType: action.userType
      }));

    default:
      return state;
  }
};

exports.layerPermissionReducer = layerPermissionReducer;